export enum ImportActivationMode {
  WEB = 'web',
  TEXT = 'text',
  PREOPT = 'preopt',
}
